module.exports = require("babel-runtime/regenerator");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/regenerator"
// module id = 40
// module chunks = 0